import React, { Component } from 'react';

import Auth from 'utils/auth';

const ClientStateContext = React.createContext();
const ClientState = ClientStateContext.Consumer;

export const CLOSED = 'closed';
export const OPEN = 'open';
export const UNRENDERED = 'unrendered';

export class ClientStateProvider extends Component {
  state = {
    modal: UNRENDERED,
    openModal: () => { this.setState({ modal: OPEN }); },
    closeModal: () => {
      this.setState({ modal: CLOSED });
      (function smoothscroll(){
        var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
             window.requestAnimationFrame(smoothscroll);
             window.scrollTo (0,currentScroll - (currentScroll/5));
        }
      })();
    },

    confirmProjectId: null,
    showConfirmation: (id) => { this.setState({ confirmProjectId: id }); },
    hideConfirmation: (id) => { this.setState({ confirmProjectId: null }); },

    menuProjectId: null,
    showMenu: (id) => { this.setState({ menuProjectId: id }); },
    hideMenu: (id) => { this.setState({ menuProjectId: null }); },

    signInEmail: null,
    saveSignInEmail: (email) => { this.setState({ signInEmail: email }); },

    allProjects: !Auth.isPermissioned("Employee"),
    showAllProjects: () => { this.setState({ allProjects: true }); },
    showMyProjects: () => { this.setState({ allProjects: false }); },
  };

  render() {
    return (
      <ClientStateContext.Provider value={this.state}>
        {this.props.children}
      </ClientStateContext.Provider>
    );
  }
};

export default ClientState;



// WEBPACK FOOTER //
// ./src/ClientState.js